// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3XtNO","title":"ClientReferral_title__1I3Et","itemText":"ClientReferral_itemText__qwrqN"};